<div class="c-progressbagStart">
  <slotcom-navigation-button
    type="close"
    (click)="closeModal()">
  </slotcom-navigation-button>

  <div class="c-progressbagStart__container">
    <div
      class="c-progressbagStart__background"
      theming
      themingGroup="progressivebag"
      themingAsset="start-background"
      [themingOverride]="event()?.assets">
      <div class="c-progressbagStart__info">
        <div
          class="c-progressbagStart__icon"
          theming
          themingGroup="progressivebag"
          themingAsset="logo"
          [themingOverride]="event()?.assets"></div>

        <div class="c-progressbagStart__text">
          <span class="text title">{{ 'home.live-ops.progressbag.modal-start.title' | translate | uppercase }}</span>

          <div class="text subtitle">
            <span>{{ 'home.live-ops.progressbag.modal-start.subtitle' | translate }}</span>
            <span
              class="type-icon-text"
              theming
              themingGroup="progressivebag"
              themingAsset="icon-points"
              [themingOverride]="event()?.assets"></span>
            <span>{{ 'home.live-ops.progressbag.modal-start.subtitle-2' | translate }}</span>
          </div>
          <span class="text subtitle subtitle-out">{{
            'home.live-ops.progressbag.modal-start.subtitle-3' | translate
          }}</span>

          <div
            class="c-progressbagStart__text__bg"
            theming
            themingGroup="progressivebag"
            themingAsset="reward-box"
            [themingOverride]="event()?.assets">
            <slotcom-display [classes]="['c-display--large c-display--large--reward']">
              <div
                displayIcon
                displayIconPos="left"
                class="c-display--coin"></div>
              <span
                class="text"
                [ngStyle]="{ 'font-size': setFontSize() }"
                >{{ maxPrize() | number: '1.0-0' : ('common.culture' | translate) }}</span
              >
            </slotcom-display>
          </div>
        </div>

        <div class="c-progressbagStart__timer">
          <span class="text">{{ 'home.live-ops.global.time-left' | translate }}</span>
          <slotcom-animated-timer
            [showInDays]="true"
            [endDate]="progressbagStartModalData.expirationDate"
            (expired)="closeModal()"></slotcom-animated-timer>
        </div>
      </div>

      <slotcom-button
        class="c-button--pink"
        (safeClick)="openProgressbag()"
        audioType="functionality">
        {{
          progressbagStartModalData.properties.buttonText[lang()]
            ? progressbagStartModalData.properties.buttonText[lang()]
            : ('home.buttons.harvest' | translate | uppercase)
        }}
      </slotcom-button>
    </div>
  </div>
</div>
